module.exports = __webpack_public_path__ + "static/img/square-purple-1.79c1998f.png";